<template>
	<div>
		<div class="row">
			<div class="configurator-info-block blog-asside-right col-md-3">
				<div class="logo-block">
					<a class="" href=""><img :src="'/images/exhibitions/' + exhibitionImage" alt=""></a>
				</div>

				<div class="configurator-info-content">
					<configurator-exhibition
						class="hidden-xs hidden-sm"
						:exhibition="exhibition">
					</configurator-exhibition>

					<Basket :views="views" />

					<PdfDocuments />
					
					<configurator-contact
						class="hidden-xs hidden-sm"
						v-show="contact"
						:contact="contact">
					</configurator-contact>
				</div>
			</div>
			<div class="configurator-content-block blog-lst col-md-9 p1" :class="views.smallBasketCollapsed ? 'show-content' : 'hide-content'">
				<ul class="list-unstyled lang-block">
					<li>
						<a href="#" @click="$i18n.locale = 'de'" :class="{'active': !inEnglish}">
							<img class="flag" src="/images/de.svg" alt=""/>
						</a>
					</li>
					<li>
						<a href="#" @click="$i18n.locale = 'en'" :class="{'active': inEnglish}">
							<img class="flag" src="/images/gb.svg" alt=""/>
						</a>
					</li>
				</ul>
				<div class="clearfix">
					<div class="wizard-container">
						<div class="wizard-card ct-wizard-orange" id="wizardProperty">
							<form @submit.prevent>
								<ul id="myTabs" class="hidden-xs hidden-sm hidden-md">
									<li 
										:class="[
											(activeTabs.key_data) ? '' : 'deactivated',
											(currentTab === 'key_data') ? 'active':''
										]">
										<a href="#" role="tab" @click="selectTab('key_data')">
											{{ $t("tab.key_data") }}
										</a>
									</li>
									<li
										:class="[
											(activeTabs.booths) ? '' : 'deactivated',
											(currentTab === 'booths') ? 'active':''
										]">
										<a href="#" role="tab" @click="selectTab('booths')">
											{{ $t("tab.booth_selection") }}
										</a>
									</li>
									<li 
										:class="[
											(activeTabs.booth_setup) ? '' : 'deactivated',
											(currentTab === 'booth_setup') ? 'active':''
										]">
										<a href="#" role="tab" @click="selectTab('booth_setup')">{{ $t("tab.booth_set_up") }}</a>
									</li>
									<li :class="[
										(activeTabs.articles) ? '' : 'deactivated',
										(currentTab === 'articles') ? 'active':''
										]">
										<a href="#" id="articlesLink" role="tab" @click="selectTab('articles')">
											{{ $t("tab.articles") }}
										</a>
									</li>
									<li :class="[
										(activeTabs.prints) ? '' : 'deactivated',
										(currentTab === 'prints') ? 'active':''
										]">
										<a
											href="#"
											id="printsLink"
											role="tab"
											@click="selectTab('prints')">
											{{ $t("tab.prints") }}
										</a>
									</li>
									<li :class="[
										(activeTabs.summary) ? '' : 'deactivated',
										(currentTab === 'summary') ? 'active':''
									]">
										<a href="#" id="summaryLink" role="tab" @click="selectTab('summary')">
											{{ $t("tab.summary") }}
										</a>
									</li>
									<li :class="[
										(activeTabs.submit) ? '' : 'deactivated',
										(currentTab === 'submit') ? 'active':''
									]">
										<a href="#" id="submitLink" role="tab" @click="selectTab('submit')">
											{{ $t("tab.submit") }}
										</a>
									</li>
								</ul>
								<div v-if="isExhibitionClosed"
									role="alert"
									class="alert alert-info"
									v-html="closedMessage">
								</div>
								<div class="tab-content">
									<configurator-key-data v-if="currentTab === 'key_data'"
										:basket="basket"
										:exhibition="exhibition"
										:is-exhibition-closed="isExhibitionClosed"
										@saveBasket="saveBasket"
										>
									</configurator-key-data>
									<configurator-booth-selector v-if="currentTab === 'booths'"
										:basket="basket"
										:booths="filteredBooths"
										:views="views"
										:is-exhibition-closed="isExhibitionClosed"
										@saveBasket="saveBasket"
										@resetDisplayedBooth="resetDisplayedBooth"
										>
									</configurator-booth-selector>
									<configurator-booth-setup v-if="currentTab === 'booth_setup'"
										:basket="basket"
										:alternativeBooths="filteredBooths"
										:colors="colors"
										:exhibition="exhibition"
										:views="views"
										:is-exhibition-closed="isExhibitionClosed"
										@saveBasket="saveBasket"
										@resetDisplayedBooth="resetDisplayedBooth"
										@unselectBooth="removeSelectedBooth"
										>
									</configurator-booth-setup>
									<configurator-booth-articles v-if="currentTab === 'articles'"
										:basket="basket"
										:views="views"
										:welcomeMessage="articlesWelcomeMessage"
										:isRestrictedAccess="isRestrictedAccess()"
										:daysToGo="daysToGo"
										:is-exhibition-closed="isExhibitionClosed"
										:class="((isTabActive('articles') && isRestrictedAccess()) ? 'active':'')"
										@saveBasket="saveBasket"
										@resetDisplayedBooth="resetDisplayedBooth"
										>
									</configurator-booth-articles>
									<configurator-prints v-if="currentTab === 'prints'"
										@resetDisplayedBooth="resetDisplayedBooth"
										@saveBasket="saveBasket">
									</configurator-prints>
									<configurator-summary v-if="currentTab === 'summary'"
										:basket="basket"
										:exhibition="exhibition"
										:netValuesOnly="netValuesOnly"
										:is-exhibition-closed="isExhibitionClosed"
										@saveBasket="saveBasket"
										@resetDisplayedBooth="resetDisplayedBooth"
										@unselectBooth="removeSelectedBooth">
									</configurator-summary>
									<configurator-submit v-if="currentTab === 'submit'"
										:basket="basket"
										:is-embedded="isEmbedded"
										:exhibition="exhibition"
										:user="user"
										:isRestrictedAccess="isRestrictedAccess()"
										:closed="isExhibitionClosed"
										:is-exhibition-closed="isExhibitionClosed"
										:booth-types="BOOTH_TYPES"
										:netValuesOnly="netValuesOnly"
										@requestSubmitted="clearBasket"
										@newUser="updateUser"
										@countryChanged="onCountryChanged"
										@restrictTab="restrictTab">
									</configurator-submit>
								</div>
							</form>
						</div>
					</div>
				</div>
				<configurator-contact
					class="hidden-md hidden-lg"
					v-show="contact"
					:contact="contact">
				</configurator-contact>
			</div>
		</div>
		<app-footer></app-footer>
		
		<configurator-modal
			:is-active="showModal"
			:booth-types="BOOTH_TYPES"
			:title="(inEnglish) ? exhibition.name_en : exhibition.name"
			:user="currentUser"
			@close="closeModal"
			@orderBooth="orderBooth"
			@orderArticles="orderArticles">
		</configurator-modal>
	</div>
</template>

<script setup>
import moment from 'moment'
import { computed, onMounted, ref, reactive, nextTick, watch, inject, provide } from 'vue'
import { useMainStore } from '@/store'
import { ARTICLE_TYPE_PRINTABLE, BOOTH_TYPES, BOOTH_TYPE_CORNER_LEFT } from '@/constants'
import { useI18n } from 'vue-i18n'
import ShoppingCart from '../classes/ShoppingCart'
import Logger from '@/services/logging'
import PdfDocuments from '@/components_new/Configurator/Panels/PdfDocuments.vue'

const { t, locale } = useI18n({ useScope: 'global' })
const store = useMainStore()
/** @type {Logger} */
const logger = inject('logger', null)
// define passed props
const props = defineProps({
	exhibition: {
		type: Object,
		required: true
	},
	categories: {
		required: true,
	},
	colors: {
		type: Array,
		default: [],
		required: true,
	},
	booths: {
		required: true,
	},
	contact: {
		required: true,
	},
	currentUser: {
		required: true,
	},
	isEmbedded: {
		required: true,
	},
	restriction: {
		required: true,
	},
	// countries: {
	// 	default: [],
	// 	required: true,
	// },
	// printingInformation: {
	// 	default: []
	// }
})
// define reactive props
const basket = ref({ // TODO: reactive would be better, but for now ref is enough
	exhibitionId: props.exhibition.id,
	width: props.isEmbedded ? props.isEmbedded.width : 0,
	depth: props.isEmbedded ? props.isEmbedded.depth : 0,
	boothType: null,
	selectedBooth: null,
	label: '',
	carpetColor: null,
	selectedArticles: [],
	showArticles: false,
	exhibitionHall: props.isEmbedded ? props.isEmbedded.exhibitionHall : "",
	exhibitionBoothNumber: props.isEmbedded ? props.isEmbedded.exhibitionBoothNumber : "",
	total: 0,
	total_gross: 0,
	computed: {
		squareMeter: 0,
		exhibitionRentCost: 0,
		exhibitionAdditionalCosts: 0,
		additionalCosts: [],
		boothCost: 0,
		labelCost: 0,
		articlesCost: 0,
		isLateDeliverySurchargeActive: false,
		lateDeliveryCost: 0,
		priceLevelCost: 0,
		priceLevelId: null,
		total: 0,
		total_gross: 0
	},
	group: null,
	restricted: false,
})

const views = reactive({
	smallBasketCollapsed: true,
	boothSetup: {
		displayedBooth: null	
	}
})
const netValuesOnly = ref(false)
const user = ref(null)
const showModal = ref(false)
const restrictedTab = ref(null)
const renderUpdate = ref(1)
// define computed props
const storedLocale = computed(() => store.settings.locale)
const storedBasket = computed(() => store.settings.basket)
const shoppingCart = computed(() => store.settings.shopping_cart)
const inEnglish = computed(() => store.inEnglish)
const activeTabs = computed(() => store.activeTabs)
const currentTab = computed(() => store.tmp.current_tab)

const squareMeter = computed(() => {
	if (shoppingCart.value.width > 0 && shoppingCart.value.depth > 0) {

		return shoppingCart.value.getSquareMeter()
	}

	return shoppingCart.value.getSquareMeter()
})

const filteredBooths = computed(() => {
	return props.booths.filter(item => {
		let itemPrices = item.pivot.prices
		if (basket != null && basket.value.boothType != null) {
			if (basket.value.boothType.type in itemPrices) {
				item.priceParams = itemPrices[basket.value.boothType.type]
				item.price = (basket.value.width * basket.value.depth) *
					parseFloat(item.priceParams.cost_per_square_meter_net)
				item.pricePerSquareMeter = parseFloat(item.priceParams.cost_per_square_meter_net)
				let itemImages = item.images
				item.previewImages = []
				item.previewImage = null
				if (basket.value.boothType.type in itemImages) {
					let images = itemImages[basket.value.boothType.type]
					for (let i = 0; i < images.length; i++) {
						if (images[i].isPreview) {
							item.previewImages.unshift(images[i])
							item.previewImage = images[i].imagePath
						} else {
							item.previewImages.push(images[i])
						}
					}
				}
				// set display name and description
				item.displayName = (inEnglish.value) ? item.name_en : item.name;
				item.displayDescription = (inEnglish.value) ? item.description_en : item.description;
				return true;
			}
		}
		return false;
	});
})

const exhibitionImage = computed(() => {
	if (props.exhibition.logo !== null && props.exhibition.logo != "") {
		return props.exhibition.logo
	}

	return "default_configurator_logo.png"
})

const articlesWelcomeMessage = computed(() => {
	if (inEnglish.value) {
		return props.exhibition.welcome_message_en
	}

	return props.exhibition.welcome_message
})

const closedMessage = computed(() => {
	return (inEnglish.value)
		? props.exhibition.closed_message_en
		: props.exhibition.closed_message
})

const isExhibitionClosed = computed(() => {
	if (props.exhibition.closed_date === null) {
		return false
	}
	let now = moment()
	let closed = moment(props.exhibition.closed_date)

	return (now.diff(closed) >= 0)
})

const daysToGo = computed(() => {
	let now = moment()
	let start = moment(props.exhibition.from)

	return start.diff(now, 'days')
})
// define watch
watch(() => locale.value, () => {
	selectLocale(locale.value)
})
// define methods
const updateUser = (userData) => {
	user.value = userData
}

const selectLocale = async (val) => {
	if (storedLocale.value === val) {
		return
	}
	store.settings.locale = val
	await axios.post('/locale', { language: val })
		.then(response => {})
		.catch(err => {
			console.error(err)
		})
}

const	getInclusiveCount = (selectedBooth, articleID) => {
	if (selectedBooth.articles.length > 0) {
		for (let i = 0; i < selectedBooth.articles.length; i++) {
			let article = selectedBooth.articles[i]
			if (article.id == articleID) {
				return article.pivot.inclusive
			}
		}
	}

	return 0
}

const getOldCount = (oldArticles, articleID) => {
	for (let i = 0; i < oldArticles.length; i++) {
		let article = oldArticles[i]
		if (article.id == articleID) {
			return (article.count - article.inclusive)
		}
	}

	return 0
}

const prepareArticle = (article, oldCount) => {
	// set language
	article.displayName = (inEnglish.value) ? article.name_en : article.name
	article.displayDescription = (inEnglish.value) ? article.description_en : article.description
	// calculate count and inclusive
	article.inclusive = 0
	article.inclusive_unit = article.unit
	article.count = oldCount
	article.currentImg = 0
	if (basket.value.selectedBooth !== null) {
		article.inclusive_unit = getInclusiveUnit(basket.value.selectedBooth, article.id)
		article.inclusive_count = getInclusiveCount(basket.value.selectedBooth, article.id)
		article.inclusive = getRealCount(article)
		article.count = article.count + parseFloat(article.inclusive)
	}
	// calculated exhibition specific prices
	article.exhibitionPrices = JSON.parse(article.pivot.prices)
	article.price = parseFloat(article.exhibitionPrices.price_net)

	return article
}

const saveBasket = () => {
	basket.value.showArticles = (
		basket.value.selectedBooth !== null
		&& basket.value.selectedBooth.articles !== null
		&& basket.value.selectedBooth.articles.length > 0
	)
	for (let i = 0; i < basket.value.selectedArticles.length; i++) {
		let article = basket.value.selectedArticles[i]
		if (article.count > 0) {
			basket.value.showArticles = true
			break
		}
	}
	store.settings.basket = basket
}

const clearBasket = () => {
	basket.value = {
		exhibitionId: props.exhibition.id,
		width: props.isEmbedded ? props.isEmbedded.width : 0,
		depth: props.isEmbedded ? props.isEmbedded.depth : 0,
		boothType: props.isEmbedded ? BOOTH_TYPES[props.isEmbedded.type] : null,
		selectedBooth: null,
		label: '',
		carpetColor: null,
		selectedArticles: [],
		showArticles: false,
		exhibitionHall: props.isEmbedded ? props.isEmbedded.exhibitionHall : "",
		exhibitionBoothNumber: props.isEmbedded ? props.isEmbedded.exhibitionHall : "",
		total: 0,
		total_gross: 0,
		computed: {
			squareMeter: 0,
			exhibitionRentCost: 0,
			exhibitionAdditionalCosts: 0,
			additionalCosts: [],
			boothCost: 0,
			labelCost: 0,
			articlesCost: 0,
			isLateDeliverySurchargeActive: false,
			lateDeliveryCost: 0,
			priceLevelCost: 0,
			priceLevelId: null,
			total: 0,
			total_gross: 0,
		},
		group: null,
		restricted: false,
	}

	shoppingCart.value.reset()
	shoppingCart.value.width = props.isEmbedded ? props.isEmbedded.width : 0
	shoppingCart.value.depth = props.isEmbedded ? props.isEmbedded.depth : 0
	shoppingCart.value.hall = props.isEmbedded ? props.isEmbedded.exhibitionHall : ''
	shoppingCart.value.booth_number = props.isEmbedded ? props.isEmbedded.exhibitionBoothNumber : ''

	saveBasket()
}

const resetDisplayedBooth = (tab = 'key_data') => {
	store.tmp.current_tab = tab
	if (tab === 'booth_setup' || store.tmp.selected_booth == null) {
		return
	}
	
	if (basket.value.selectedBooth == null) {
		store.tmp.selected_booth = null
		store.tmp.selected_booth = null

		return
	}

	if (basket.value.selectedBooth.id != store.tmp.selected_booth.id) {
		store.tmp.selected_booth = null
		store.tmp.selected_booth = null

		return
	}
}

const selectTab = (tab) => {
	resetDisplayedBooth(tab)
	store.updateCurrentTab(tab)
}

const removeSelectedBooth = () => {
	basket.value.selectedBooth = null
	basket.value.carpetColor = null
	basket.value.label = ""
	for (let i = 0; i < basket.value.selectedArticles.length; i++) {
		let article = basket.value.selectedArticles[i];
		if (article.inclusive > 0) {
			article.count = article.count - article.inclusive
			article.inclusive = 0
		}
	}
	
	saveBasket()
}

const isRestrictedAccess = () => {
	return (
		restrictedTab.value !== undefined
		&& restrictedTab.value !== null
		&& restrictedTab.value !== ''
	)
}

const isTabActive = (tab) => {
	if (isRestrictedAccess()) {
			return restrictedTab.value === tab
	}
	
	return true
}

const isBasketSet = () => {
	//@TODO: here we need a better logic to define if the basket must be set
	if (isRestrictedAccess()) {
		return true
	}

	return (shoppingCart.value.width && shoppingCart.value.width > 0)
		&& (shoppingCart.value.depth && shoppingCart.value.depth > 0)
		&& shoppingCart.value.booth_type !== null
}

const getInclusiveUnit = (selectedBooth, articleID) => {
	if (selectedBooth.articles.length > 0) {
		for (let i = 0; i < selectedBooth.articles.length; i++) {
			let article = selectedBooth.articles[i]
			if (article.id === articleID) {
				return article.pivot.unit
			}
		}
	}

	return 'pc'
}

const getRealCount = (article) => {
	if (article.inclusive_unit === 'sqm') {
		return Math.floor(squareMeter.value * article.inclusive_count)
	}
	return article.inclusive_count
}

const onCountryChanged = (country) => {
	netValuesOnly.value = !country.vat_display_required
	store.tmp.net_value_only = !country.vat_display_required
}

const openModal = () => {
	showModal.value = true
}

const closeModal = () => {
	showModal.value = false
}

const orderArticles = async (request) => {
	clearBasket()
	shoppingCart.value.group = request.group
	const boothIndex = BOOTH_TYPES.findIndex((type) => type.type === request.booth_type)
	if (boothIndex > -1) {
		basket.value.boothType = BOOTH_TYPES[boothIndex]
		shoppingCart.value.setBoothType(BOOTH_TYPES[boothIndex])
	}
	basket.value.width = request.booth_width
	basket.value.depth = request.booth_depth
	basket.value.label = request.booth_label
	basket.value.exhibitionHall = request.exhibition_hall
	basket.value.exhibitionBoothNumber = request.exhibition_booth_number
	shoppingCart.value.setWidthAndDepth(request.booth_width, request.booth_depth)
	restrictedTab.value = 'articles'
	basket.value.restricted = true
	store.tmp.current_tab = 'articles'
	$('#articlesLink').click()
	await nextTick()
	$('#articlesLink').parent().addClass('active')
	closeModal()
	store.updateActiveTabs()
}

const orderBooth = (request) => {
	clearBasket()
	shoppingCart.value.group = request.group + 1
	modifyCategories()
		.then(({categories, articles}) => {
			store.tmp.categories = categories
			basket.value.selectedArticles = articles
		})
	closeModal()
	store.updateActiveTabs()
}

const restrictTab = async (tab, source = null) => {
	restrictedTab.value = tab
	basket.value.restricted = true
	if (source === 'step6') {
		renderUpdate.value++;
		await nextTick()
		$('#submitLink').parent().addClass('active')
		$('#articlesLink').parent().removeClass('active')
	}
	store.updateActiveTabs()
}

const isShopClosed = () => {
	if (props.exhibition.closed_date === null) {
		return false
	}
	let now = moment()
	let closed = moment(props.exhibition.closed_date)

	return (now.diff(closed) >= 0)
}

const calculateDaysToGo = () => {
	let now = moment()
	let start = moment(props.exhibition.from)

	return start.diff(now, 'days')
}

const getCountries = async () => {
	await axios.get('/configurator/countries')
		.then(response => {
			store.tmp.countries = response.data
		})
		.catch(err => {
			logger.error('loading countries failed', err.toString())
		})
}

const updateSelectedBoothInStore = () => {
	const selectedBooth = props.booths.find((booth) => {
		return booth.id === basket.value.selectedBooth.id
	})

	shoppingCart.value.selectBooth(_.cloneDeep(selectedBooth))
	if (selectedBooth.files) {
		store.tmp.booth_package_documents = Object.values(_.cloneDeep(selectedBooth.files))
	}
}

const modifyCategories = () => {
	return new Promise(async (resolve) => {
		const oldArticles = _.cloneDeep(basket.value.selectedArticles)
		const updatedArticles = [] // clear selected articles
		const modifiedCategories = await props.categories.filter(item => {
			if (item.articles != null) {
				for (let articleIndex = 0; articleIndex < item.articles.length; articleIndex++) {
					let article = prepareArticle(
						item.articles[articleIndex],
						getOldCount(oldArticles, item.articles[articleIndex].id)
					)
					item.articles[articleIndex] = article
					updatedArticles.push(article)
				}
			}
			if (item.subCategories != null) {
				for (let subCategoryIndex = 0; subCategoryIndex < item.subCategories.length; subCategoryIndex++) {
					let subCategory = item.subCategories[subCategoryIndex];
					if (subCategory.articles != null) {
						for (let articleIndex = 0; articleIndex < subCategory.articles.length; articleIndex++) {
							let subCategoryArticle = prepareArticle(
								subCategory.articles[articleIndex],
								getOldCount(oldArticles, subCategory.articles[articleIndex].id)
							)
							item.subCategories[subCategoryIndex].articles[articleIndex] = subCategoryArticle;
							updatedArticles.push(subCategoryArticle);
						}
					}
				}
			}

			return true
		});

		resolve({
			categories: modifiedCategories,
			articles: updatedArticles
		})
	})
	
}

onMounted(async () => {
	user.value = props.currentUser
	// This mode hides late delivery charge and changes the calculation.
	// It's necessary because Lueco used the standard prices for early bird sale
	// and misused the late delivery charge for standard prices
	store.tmp.early_bird_mode = [36, 37].includes(props.exhibition.id)
	store.tmp.late_delivery = props.exhibition.late_delivery
	store.tmp.characters_inclusive = props.exhibition.characters_inclusive
	if (
		storedBasket.value
		&& storedBasket.value.computed !== null
		&& storedBasket.value.exhibitionId === props.exhibition.id
	) {
		basket.value = storedBasket.value
		if (basket.value.selectedBooth != null) {
			store.tmp.selected_booth = basket.value.selectedBooth
		}
	}
	
	if (
		shoppingCart.value === undefined
		|| shoppingCart.value === null
		|| shoppingCart.value.exhibition_id !== props.exhibition.id
	) {
		store.settings.shopping_cart = new ShoppingCart({ exhibition_id: props.exhibition.id })
		if (basket.value.selectedBooth != null) {
			updateSelectedBoothInStore()
		}
	} else if (basket.value.selectedBooth != null) {
		updateSelectedBoothInStore()
	}
	// restrict only if we are in the inventory view
	// restriction on route removed on 02.05 - we need it on more routes
	// if (window.location.href.indexOf('/inventory/') !== -1) {
	if (props.restriction && props.restriction !== '') {
		restrictedTab.value = props.restriction
		basket.value.boothType = []
		basket.value.restricted = true
		store.updateActiveTabs()
	}

	store.tmp.is_exhibition_closed = isShopClosed()
	store.tmp.days_to_go = calculateDaysToGo()
	store.tmp.exhibition_slug = props.exhibition.slug
	store.exhibition.cost_booth_by_type = props.exhibition.prices.cost_booth_by_type
	// store.tmp.printing_information = props.printingInformation
	store.fetchAvailability()

	if (
		props.currentUser !== null
		&& props.currentUser.requests !== undefined
		&& props.currentUser.requests !== null
		&& props.currentUser.requests.length > 0
	) {
		openModal()
	}

	modifyCategories()
		.then(({categories, articles}) => {
			store.tmp.categories = categories
			basket.value.selectedArticles = articles
		})
	await store.fetchDocuments()
	await store.fetchExhibitionInformation()
	await getCountries()
	store.updateChecklist()
	store.updateActiveTabs()
})
</script>
